import axios from "axios";
import { baseApiUrl, getHttpHeaders, httpRequest } from "./ApiUtils";

const templateApiUrl = `${baseApiUrl}/api/Templates`;

export async function getTemplates() {
    return await httpRequest(fetchTemplates.bind(this));
}

async function fetchTemplates() {
    let config = getHttpHeaders();
    return await axios.get(`${templateApiUrl}`, config);
}

export async function getTemplateQuestions(id) {
    return await httpRequest(fetchTemplateQuestions.bind(this, id));
}

async function fetchTemplateQuestions(id) {
    let config = getHttpHeaders();
    return await axios.get(`${templateApiUrl}/${id}/Questions`, config);
}

export async function updateQuestion(question) {
    return await httpRequest(putQuestion.bind(this, question));
}

async function putQuestion(question) {
    let config = getHttpHeaders();
    return await axios.put(`${templateApiUrl}`, question, config);
}
